define('modules/lp_leads/views/lead_listing_item',['require','exports','module','base/itemview','ldsh!../templates/lead_listing_item','ldsh!../templates/lead_column'],function(require, exports, module) {
  "use strict";

  var ItemView = require("base/itemview");

  module.exports = ItemView.extend({
    tagName: "tr",
    template: require("ldsh!../templates/lead_listing_item"),
    columnTemplate: require("ldsh!../templates/lead_column"),
    triggers: {
      "click .js-show-defaults": "defaults:show",
      "click .js-show-integrations": "integrations:show"
    },
    setColumnNames: function(names) {
      this.columnNames = _.without(names, "timestamp", "step");
    },
    _createColumn: function(columnName, index, columns, transform) {
      var value = this.model.get(columnName),
          className = "";
      if (columnName === "timestamp") className = "font-secondary";
      value = (transform && transform(value)) || value || "";
      return $(this.columnTemplate({ value: value, className: className }));
    },
    onRender: function() {
      var columns = [
            this._createColumn("timestamp", 0, undefined, function(value) { return new Date(value*1000).toLocaleString(); }),
            this._createColumn("step")
          ].concat(
            _.map(this.columnNames, this._createColumn, this)
          );
      this.$el.prepend(columns);
      return this;
    }
  });

});

